
const modeTypes = {
  '-2': 'Undefined',
  '-1': 'Unknown',
  '0': 'Bike',
  '1': 'Car',
  '2': 'Passenger',
  '3': 'Pedestrian',
  '4': 'Public transport',
  '5': 'Truck',
  '6': 'Park and ride',
  '7': 'Taxi',
  '11': 'Car sharing (station-based)',
  '12': 'Car sharing (free-floating)',
  '15': 'E-Scooter',
  '16': 'Pedelec',
  '17': 'Bike sharing',
  '21': 'Ride pooling',
  '22': 'Ride hailing',
  '23': 'Premium ride hailing',
}

export function getInfoStrings(trip) {
  return [
    trip.tripBeginDay + ', ' + trip.tripBeginTime + ' - ' + trip.tripEndDay + ', ' + trip.tripEndTime,
    parseFloat(trip.durationTrip).toFixed(2) + ' min – ' + parseFloat(trip.distanceInKm).toFixed(2) + ' km – ' + parseFloat(trip.avgSpeedInKph).toFixed(2) + ' km/h',
    modeTypes[trip.tripMode]
  ]
}
